import { render, staticRenderFns } from "./RecentItems.vue?vue&type=template&id=1dbc2d5d&scoped=true&"
import script from "./RecentItems.vue?vue&type=script&lang=js&"
export * from "./RecentItems.vue?vue&type=script&lang=js&"
import style0 from "./RecentItems.vue?vue&type=style&index=0&id=1dbc2d5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc2d5d",
  null
  
)

/* custom blocks */
import block0 from "./RecentItems.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports